<template>
  <div :class="pageSource == 'detail' ? 'seating-v2' : 'seating-v2 seating-v2-mini'">
    <div class="seat-chart-content">
      <div class="screen" :style="`width:${rowWidth - form.columnSpacing}px;margin-bottom:${form.lineSpacing}px;`"></div>
      <div
        :class="form.lineSpacing == 0 ? 'seat-line clearfix' : 'seat-line clearfix line-gap'"
        v-for="(row, rowIndex) in form.seats"
        :key="rowIndex"
        :style="`width:${rowWidth}px;margin-bottom:${form.lineSpacing}px;`"
      >
        <div :class="colTitle[rowIndex] ? 'seat-item letter-title' : 'seat-item'" :style="`margin-right:${form.columnSpacing}px`">{{ colTitle[rowIndex] }}</div>
        <div
          :class="setSeatClass(rowIndex, colIndex)"
          v-for="(col, colIndex) in row"
          :key="colIndex"
          @click="clickSeat(rowIndex, colIndex)"
          :style="`transform:translateX(${col.translate * 100}%);margin-right:${form.columnSpacing}px;z-index:${(col.whiteBg ? 0 : 2) + (col.translate == 0 ? 1 : 2)}`"
        >
          <template v-if="col.text !== '' && col.text >= 0 && !col.whiteBg">{{ col.text }}</template>
          <i class="el-icon-edit edit-seat-num" @click.stop="editNum(rowIndex, colIndex)" v-if="col.text !== '' && col.seatStatus != 'delete' && !col.whiteBg"></i>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$locale('theatre.editSeatNumber')"
      :visible.sync="dialogVisible"
      width="250px"
      :show-close="false"
      :close-on-click-modal="false"
      
    >
      <el-input v-model="seatNum" @input="inpupNum"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button class="egl-btn-white" @click="dialogVisible = false">{{ $locale("global.cancel") }}</el-button>
        <el-button class="egl-btn-yellow" @click="updateSeatNum">{{ $locale("global.save") }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="seatSettingDialog"
      :title="$locale('theatre.seatTypeSetting')"
      class="seatSeatingDialog"
      :close-on-click-modal="false"
    >
      <SeatSettingItemVue
        v-for="setting in seatSettings"
        :key="setting.seatStatus"
        :seatSetting="setting"
      />
      <div class="dialogBtns">
        <el-button class="cancel" @click="$emit('closeDialog')">{{$locale("trans.report.status.cancel")}}</el-button>
        <el-button class="confirm" @click="saveSetting">{{$locale("global.confirm2")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  createSeats,
  addCol,
  addRow,
  setSeatNumber,
  translateSeats,
  deleteSeatRow,
  createSeatSetting
} from "@/assets/js/theatre.js";
import "@/assets/style/seatChart.less";
import SeatSettingItemVue from "@/components/Theatre/SeatSettingItem.vue";

export default {
  name: "theatre-seating-v2",
  components: {
    SeatSettingItemVue
  },
  data() {
    return {
      seatSettings: createSeatSetting(),
      form: {
        lineSpacing: 0,
        columnSpacing: 0,
        seatDecorator: createSeatSetting(),
        seats: [],
      },
      colTitle: [],
      rowWidth: 0,
      choosedSeats: [],
      lastClickSeat: [],
      dialogVisible: false,
      seatAxis: [],
      seatNum: "",
      girdWdith: 50,
      rowOrder: "order",
      colOrder: "order",
      seatSettingDialog: false
    };
  },
  methods: {
    initForm() {
      let { seats, colTitle } = createSeats(this.linesNumber, this.columnsNumber, this.rowOrder, this.colOrder);

      this.form = { ...this.form, seats };
      this.colTitle = colTitle;
      this.setRowWidth(seats[0].length);
      this.lastClickSeat = [];
      this.choosedSeats = [];
    },
    setRowWidth(columnLength) {
      let rowWidth = 0;
      let spacing = parseInt(this.seatingPlan.columnSpacing) || 0;

      if (this.pageSource != "detail") {
        spacing = 0;
      }

      rowWidth = (columnLength + 1) * (this.girdWdith + spacing);

      this.rowWidth = rowWidth;
    },
    setSeat(seatType) {
      let seats = JSON.parse(JSON.stringify(this.form.seats));
      let choosedSeats = [ ...this.choosedSeats ];
      let commonSeat = ["general", "vip", "special", "close", "delete", "accidentClose", "wheelchair", "posCounter"];
      let unlimitedSeat = [ "enter", "exit", "stairs", "down" ];
      // 设备格子（出入口/楼梯等）或白色装饰格子：保留原逻辑，只能改为设备或删除，不能变成座位。
      // 真实座位（即使因删列后落在边界，如 a8）则允许修改为各种座席種類 / 情侣座。
      const isFrameOrDevice = (row, col) =>
        seats[row][col].whiteBg || unlimitedSeat.indexOf(seats[row][col].seatStatus) >= 0;
      // 已删除座位（delete）：从 schedule 跳转进来时（schedule-update 路由）不允许修改为任何座席種類 / 设备，保持删除状态。
      const isDeleted = (row, col) => this.isScheduleRoute && seats[row][col].seatStatus === "delete";

      if (choosedSeats.length > 0) {
        if (seatType == "lovers") {
          let loversArr = [];

          for (let i = 0; i < choosedSeats.length; i++) {
            if (loversArr.indexOf(choosedSeats[i]) >= 0) {
              continue;
            } else {
              let axis = choosedSeats[i].split(",");
              let row = parseInt(axis[0]);
              let col = parseInt(axis[1]);
              let leftSeat = `${row},${col - 1}`;
              let rightSeat = `${row},${col + 1}`;
              
              if (!isFrameOrDevice(row, col) && !isDeleted(row, col)) {
                // 配对的另一半（左/右座位）同样不能是设备/装饰白格子或已删除座位，
                // 否则会把删除座位（如 E1）错误地变成情侣座。
                if (choosedSeats.indexOf(rightSeat) >=0 && loversArr.indexOf(rightSeat) < 0 && col != this.form.seats[0].length - 2 && !isFrameOrDevice(row, col + 1) && !isDeleted(row, col + 1)) {
                  loversArr.push(choosedSeats[i]);
                  loversArr.push(`${row},${col + 1}`);
                  seats[row][col].seatStatus = seatType;
                  seats[row][col].link = seats[row][col + 1].text;
                  seats[row][col + 1].seatStatus = seatType;
                  seats[row][col + 1].link = seats[row][col].text;
                } else if (choosedSeats.indexOf(leftSeat) >=0 && loversArr.indexOf(leftSeat) < 0 && col != 1 && !isFrameOrDevice(row, col - 1) && !isDeleted(row, col - 1)) {
                  loversArr.push(choosedSeats[i]);
                  loversArr.push(`${row},${col - 1}`);
                  seats[row][col].seatStatus = seatType;
                  seats[row][col].link = seats[row][col - 1].text;
                  seats[row][col - 1].seatStatus = seatType;
                  seats[row][col - 1].link = seats[row][col].text;
                } else {
                  seats[row][col].seatStatus = "general";
                  seats[row][col].whiteBg = false;
                  seats[row][col].link = "";
                }
              }
            }
          }
        } else {
          for (let i = 0; i < choosedSeats.length; i++) {
            let [ row, col ] = choosedSeats[i].split(",");

            // 从 schedule 跳转进来时，已删除座位（delete）不允许修改为任何座席種類 / 设备，保持删除状态。
            if (isDeleted(row, col)) {
              continue;
            }

            if (isFrameOrDevice(row, col)) {
              // 设备 / 装饰白格子：只能改为设备或删除
              if (unlimitedSeat.indexOf(seatType) >= 0 || seatType === "delete") {
                seats[row][col].seatStatus = seatType;
              }
            } else if (commonSeat.indexOf(seatType) >= 0 || unlimitedSeat.indexOf(seatType) >= 0) {
              // 真实座位（含删列后落在边界的座位，如 a8）：可设置座席種類或设备
              seats[row][col].seatStatus = seatType;
            }

            seats[row][col].link = "";
          }
        }

        this.choosedSeats = [];
        this.form = { ...this.form, seats };
        this.lastClickSeat = [];
      }
    },
    clickSeat(row, col) {
      if (this.pageSource != "detail") {
        return;
      }
      let seats = [ ...this.choosedSeats ];
      let seatIndexText = row + "," + col;
      let lastClickSeat = [ row, col ];
      let linkSeat = "";

      if (this.form.seats[row][col].link != "") {
        for (let i = 0; i < this.form.seats[row].length; i++) {
          if (this.form.seats[row][col].link == this.form.seats[row][i].text) {
            linkSeat = row + "," + i;
            break;
          }
        }
      }

      if (seats.indexOf(seatIndexText) >= 0) {
        seats.splice(seats.indexOf(seatIndexText), 1);
        lastClickSeat = [];

        if (linkSeat != "") {
          seats.splice(seats.indexOf(linkSeat), 1);
        }
      } else {
        seats.push(seatIndexText);

        if (linkSeat != "") {
          seats.push(linkSeat);
        }
      }

      if (seats.length == 0) {
        lastClickSeat = [];
      }

      this.choosedSeats = seats;
      this.lastClickSeat = lastClickSeat;
    },
    setSeatClass(row, col) {
      let className = "seat-item";
      let seatIndexText = [row, col].toString();

      className = className + " " + this.form.seats[row][col].seatStatus;

      if (this.choosedSeats.indexOf(seatIndexText) >= 0) {
        className = className + " choosed";
      }

      if (this.lastClickSeat.length > 0) {
        if (row == this.lastClickSeat[0] || col == this.lastClickSeat[1]) {
          className = className + " shadow-bg";
        }
      }

      if (this.seatingPlan.columnSpacing != 0) {
        className += " column-gap"
      }

      return className
    },
    deleteRow() {
      if (this.lastClickSeat.length > 0 && this.lastClickSeat[0] != 0 && this.lastClickSeat[0] != this.form.seats.length - 1 && this.form.seats.length > 3) {
        const that = this;
        const deletRowText = that.$locale("theatre.delete.rowspan") + that.form.seats[that.lastClickSeat[0]][0].sid.replace(/[^\a-zA-Z]/g, "");
        const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${deletRowText}</span>`;

        that.$confirm(confirmHtml, "", {
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "egl-btn-white",
          cancelButtonText: this.$locale("global.cancel"),
          showConfirmButton: true,
          confirmButtonClass: "egl-btn-yellow",
          confirmButtonText: this.$locale("global.delete"),
          customClass: "egl-confirm",
          closeOnClickModal: false,
        }).then(() => {
          let { newSeat, colTitle } = deleteSeatRow(that.lastClickSeat[0], that.form.seats);

          that.form = {
            ...that.form,
            seats: newSeat,
          };
          that.colTitle = colTitle;
          that.lastClickSeat = [];
          that.choosedSeats = [];
        }).catch(() => {});
      }
    },
    deleteCol() {
      if (this.lastClickSeat.length > 0 && this.lastClickSeat[1] != 0 && this.lastClickSeat[1] != this.form.seats[0].length - 1 && this.form.seats[0].length > 3) {
        const that = this;
        const deleteColText = that.$locale("theatre.delete.column") + that.form.seats[that.lastClickSeat[0]][that.lastClickSeat[1]].sid.replace(/[^\d]/g, "");
        const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${deleteColText}</span>`;

        that.$confirm(confirmHtml, "", {
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "egl-btn-white",
          cancelButtonText: this.$locale("global.cancel"),
          showConfirmButton: true,
          confirmButtonClass: "egl-btn-yellow",
          confirmButtonText: this.$locale("global.delete"),
          customClass: "egl-confirm",
          closeOnClickModal: false,
        }).then(() => {
          let col = that.lastClickSeat[1];
          let seats = JSON.parse(JSON.stringify(that.form.seats));
          let rowWidth = 0;

          seats.map(rowItem => {
            let linkSeatIndex = -1;

            if (rowItem[col].link != "") {
              if ((that.colOrder == "order" && rowItem[col].link > rowItem[col].text) || (that.colOrder != "order" && rowItem[col].link < rowItem[col].text)) {
                rowItem[col + 1].link = "";
                rowItem[col + 1].seatStatus = "general";
              } else {
                rowItem[col - 1].link = "";
                rowItem[col - 1].seatStatus = "general";
              }
            }

            rowItem.splice(col, 1);
          });

          rowWidth = (seats[0].length + 1) * ( 50 + that.seatingPlan.columnSpacing);

          that.form = {
            ...that.form,
            seats,
          };
          that.lastClickSeat = [];
          that.choosedSeats = [];
          that.rowWidth = rowWidth;
        }).catch(() => {});
      }
    },
    editNum(row, col) {
      this.dialogVisible = true;
      this.seatAxis = [row, col];
      this.seatNum = this.form.seats[row][col].text;
    },
    updateSeatNum() {
      let newSeats = setSeatNumber(this.form.seats, this.seatAxis, this.seatNum, this.colOrder);
      let form = JSON.parse(JSON.stringify(this.form));

      form.seats = newSeats;

      this.dialogVisible = false;
      this.form = form;
    },
    inpupNum() {
      let num = this.seatNum.replace(/[^\d.]/g, "");
      this.seatNum = num;
    },
    handleSeat(obj) {
      let seats = [];
      let rowWidth = this.rowWidth;
      let colTitle = [ ...this.colTitle ];

      switch (obj.type) {
        case "addCol":
          seats = addCol(this.form.seats, this.colOrder);
          rowWidth = (seats[0].length + 1) * ( 50 + this.seatingPlan.columnSpacing);
          break;
        
        case "addRow":
          seats = addRow(this.form.seats, this.rowOrder, this.colOrder, this.colTitle).newSeats;
          colTitle = addRow(this.form.seats, this.rowOrder, this.colOrder, this.colTitle).newColTitle;
        break;
      }

      this.form = {
        ...this.form,
        seats,
      };
      this.rowWidth = rowWidth;
      this.colTitle = colTitle;
    },
    setTranslate(orientation) {
      if (this.lastClickSeat.length != 0) {
        let newSeats = translateSeats(this.form.seats, this.lastClickSeat, orientation);

        this.form = {
          ...this.form,
          seats: newSeats,
        };
      }
    },
    resetRowOrder() {
      this.rowOrder = this.rowOrder == "order" ? "reverse" : "order";
      this.initForm();
    },
    resetColOrder() {
      this.colOrder = this.colOrder == "order" ? "reverse" : "order";
      this.initForm();
    },
    saveSetting() {
      // 检查表单deviceType是否有空值
      const _list = this.seatSettings;
      for(let i = 0; i < _list.length; i++) {
        const invalidMsg = _list[i].warningMsg.some(msg => !msg.deviceType && msg.message || (!msg.deviceType && !msg.message &&
        _list[i].warningMsg.length > 1));
        if (invalidMsg) {
          this.$message({
            message: _list[i].decorationName + "デバイスを選択してください",
            type: "warning",
          });
          return;
        }
      }
      // 只传递有修改过的座位信息
      let validSettings = [];
      validSettings = _list.map(item => ({
        ...item,
        warningMsg: item.warningMsg.every(msg => msg.deviceType) ? item.warningMsg : []
      }));
      this.form.seatDecorator = validSettings;
      this.$emit("setSeatDecorator", validSettings, this.form.seats);
      this.$emit("closeDialog");
    },
  },
  mounted() {
    if (this.pageSource != "detail") {
      let girdWdith = 20;
      let rowWidth = 0;
      let colTitle = [];
      let colOrder = "order";
      let rowOrder = "order";
      let columnSpacing = 0;

      rowWidth = (this.seatingPlan.seats[0].length + 1) * girdWdith;

      this.seatingPlan.seats.map(rowItem => {
        colTitle.push(rowItem[1].rowString);
      });
      if (colTitle.length >= 4 && colTitle[1].charCodeAt() > colTitle[2].charCodeAt()) {
        rowOrder = "reverse";
      }
      if (this.seatingPlan.seats[1].length >= 4 && this.seatingPlan.seats[1][1].text > this.seatingPlan.seats[1][2].text) {
        colOrder = "reverse";
      }

      this.girdWdith = girdWdith;
      this.form = {
        ...this.form,
        ...this.seatingPlan,
        columnSpacing: 0,
      };
      this.rowWidth = rowWidth;
      this.colTitle = colTitle;
      this.colOrder = colOrder;
      this.rowOrder = rowOrder;
    }
  },
  props: {
    seatingPlan: {
      type: Object,
      default: () => {},
    },
    linesNumber: {
      type: Number,
      default: () => 4,
    },
    columnsNumber: {
      type: Number,
      default: () => 6,
    },
    pageSource: {
      type: String,
      default: () => "detail"
    },
    isScheduleRoute: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    "seatingPlan.lineSpacing" () {
      this.form = { ...this.form, lineSpacing: this.seatingPlan.lineSpacing };
    },
    "seatingPlan.columnSpacing" () {
      let spacing = parseInt(this.seatingPlan.columnSpacing.toString().replace(/[^\d]/g, "")) || 0;

      this.form = { ...this.form, columnSpacing: spacing };
      this.setRowWidth(this.form.seats[0].length, spacing);
    },
    linesNumber() {
      this.initForm();
    },
    columnsNumber() {
      this.initForm();
    },
    "seatingPlan.seats" () {
      if (this.seatingPlan.seats.length > 0) {
        let rowWidth = 0;
        let colTitle = [];
        let colOrder = "order";
        let rowOrder = "order";
        let spacing = this.seatingPlan.columnSpacing;
        let girdWdith = this.girdWdith;

        if (this.pageSource != "detail") {
          spacing = 0;
          girdWdith = 20;
        }

        rowWidth = (this.seatingPlan.seats[0].length + 1) * (girdWdith + spacing);
        this.seatingPlan.seats.map(rowItem => {
          colTitle.push(rowItem[1].rowString);
        });
        if (colTitle.length >= 4 && colTitle[1].charCodeAt() > colTitle[2].charCodeAt()) {
          rowOrder = "reverse";
        }
        if (this.seatingPlan.seats[1].length >= 4 && this.seatingPlan.seats[1][1].text > this.seatingPlan.seats[1][2].text) {
          colOrder = "reverse";
        }

        this.form = {
          ...this.form,
          ...this.seatingPlan,
          columnSpacing: spacing,
        };
        this.rowWidth = rowWidth;
        this.colTitle = colTitle;
        this.colOrder = colOrder;
        this.rowOrder = rowOrder;
      } else {
        this.initForm();
      }
    },
  },
};
</script>
<style scoped lang="scss">
  .seatSeatingDialog{
  ::v-deep > .el-dialog {
    width: 80%;
  }
  .dialogBtns {
    display: flex;
    justify-content: center;
    margin-top: 264px;
    .el-button {
      width: 200px;
      height: 50px;
      font-size: 16px;
      font-weight: 400;
      color: #181818;
      border-radius: 3px;
      &.cancel {
        border: 2px solid #F9DA49;
        margin-right: 20px;
        &:hover {
          background-color: #FFF;
        }
      }
      &.confirm {
        background-color: #F9DA49;
      }
    }
  }
}
</style>
